import { Tooltip, Tag } from "antd";
import { ReactNode, CSSProperties } from "react";

interface TooltipTagProps {
  tooltipTitle?: ReactNode;
  tooltipDelay?: number;
  tagColor?: string;
  tagStyle?: CSSProperties;
  textColor?: string;
  icon?: ReactNode;
  children?: ReactNode;
  [key: string]: unknown;
}

const TooltipTag = ({
  tooltipTitle = "Tag tooltip",
  tooltipDelay = 1,
  tagColor = "white",
  tagStyle = {},
  textColor = "black",
  icon = null,
  children,
  ...props
}: TooltipTagProps) => {
  const defaultTagStyle = {
    borderRadius: "100px",
  };

  const mergedTagStyle = { ...defaultTagStyle, ...tagStyle };

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={tooltipDelay}>
      <Tag color={tagColor} style={mergedTagStyle} variant="solid" {...props}>
        {icon ? <span style={{ marginRight: 4 }}>{icon}</span> : null}
        <span style={{ color: textColor }}>{children}</span>
      </Tag>
    </Tooltip>
  );
};

export default TooltipTag;
